<template>
  <div class="box">
    <component
      :is="statusCom"
      :is-xiaoman-type="verifyType===XIAOMAN_VERTIFY"
      :message="verifyErrorMessage"
      :auth-path="authPath"
      :close="isClose"
      :onchange="handleClose"
      :verify-type="verifyType"
      :ali-vertify="ALI_VERTIFY"
    />
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import {
    VERIFY_STATUS_NONE,
    VERIFY_STATUS_NONE_OVERSEA,
    VERIFY_STATUS_PENDING,
    VERIFY_STATUS_TRIAL_PASS,
    VERIFY_STATUS_PASS,
    VERIFY_STATUS_REFUSE,
    VERIFY_STATUS_REFUSE_OVERSEA,
    XIAOMAN_VERTIFY,
    ALI_VERTIFY,
  } from '@utils/constants'
  import Cookies from 'js-cookie'
  import StatusNone from './components/StatusNone'
  import StatusPass from './components/StatusPass'
  import StatusTrialPass from './components/StatusTrialPass'
  import StatusPending from './components/StatusPending'
  import StatusRefuse from './components/StatusRefuse'

  const mapCom = {
    [VERIFY_STATUS_NONE]: StatusNone,
    [VERIFY_STATUS_NONE_OVERSEA]: StatusNone,
    [VERIFY_STATUS_PENDING]: StatusPending,
    [VERIFY_STATUS_TRIAL_PASS]: StatusTrialPass,
    [VERIFY_STATUS_PASS]: StatusPass,
    [VERIFY_STATUS_REFUSE]: StatusRefuse,
    [VERIFY_STATUS_REFUSE_OVERSEA]: StatusRefuse,
  }

  const VERIFY_DIALOG_KEY = 'mall_verify_dialog'

  export default {
    name: 'AuthMessage',
    computed: {
      ...mapGetters("main", [
        "isOversea",
        "verifyStatus",
        "verifyErrorMessage",
        "authPath",
        "verifyType"
      ]),
      statusCom () {
        return mapCom[this.verifyStatus]
      },
      isClose () {
        return Cookies.get(VERIFY_DIALOG_KEY)
      }
    },
    data() {
      return {
        XIAOMAN_VERTIFY,
        ALI_VERTIFY
      };
    },
    methods: {
      handleClose () {
        let domain = '.xiaoman.cn'
        if (location.origin.indexOf('okki.com') > -1) {
          domain = '.okki.com'
        }

        Cookies.set(VERIFY_DIALOG_KEY, 1, {
          expires: 7,
          path: '/',
          domain,
        })
      }
    },
    components: {
      StatusNone,
      StatusPass,
      StatusTrialPass,
      StatusPending,
      StatusRefuse
    }
  }
</script>
<style lang="scss" scoped>
  .box{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
  }
  .mm-alert{
    width: 100%;
  }
</style>


